import * as React from "react"
const Milk = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}>
    <path
      fill="#fff"
      stroke="#010101"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4 11h10v18H4z"
    />
    <path
      fill="#E2E2E2"
      stroke="#010101"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M14 29h8V11l-4-4-4 4v18Z"
    />
    <path
      fill="#fff"
      stroke="#010101"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M7.5 7H18l-4 4H4l3.5-4ZM8 3v4h10V3H8Z"
    />
    <path fill="#AEDEFA" d="M18 17h10l-1.25 13h-7.5L18 17Z" />
    <path fill="#fff" d="M18 22h10l-1.25 8h-7.5L18 22Z" />
    <path
      stroke="#010101"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M18 17h10l-1.25 12h-7.5L18 17Z"
    />
    <path
      stroke="#010101"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m19 22 1.333.25a7.236 7.236 0 0 0 2.667 0v0a7.236 7.236 0 0 1 2.667 0L27 22.5"
    />
  </svg>
)
export default Milk
